import React from 'react';

const RoleSelection = ({ scenario, onRoleSelect }) => {
  if (!scenario) return null;

  console.log("Received scenario data in RoleSelection:", scenario);
  
  // Let's log individual properties to debug
  console.log("Scenario details:", {
    detailed_scenario_description: scenario.detailed_scenario_description,
    role1_name: scenario.role1_name,
    role1_description: scenario.role1_description,
    role2_name: scenario.role2_name,
    role2_description: scenario.role2_description,
    role3_name: scenario.role3_name,
    role3_description: scenario.role3_description
  });

  const roles = [
    { name: scenario.role1_name || "Role 1", description: scenario.role1_description || "Description not available" },
    { name: scenario.role2_name || "Role 2", description: scenario.role2_description || "Description not available" },
    { name: scenario.role3_name || "Role 3", description: scenario.role3_description || "Description not available" }
  ];

  // Function to render paragraphs with proper line breaks
  const renderText = (text) => {
    return text.split('\n').map((paragraph, index, array) => {
      if (!paragraph.trim()) {
        return index < array.length - 1 ? <br key={index} /> : null;
      }
      return <p key={index} style={{ marginBottom: '0.7rem' }}>{paragraph}</p>;
    });
  };

  return (
    <div>
      <div className="card">
        <h2>Your 2035 Scenario</h2>
        <div style={{ textAlign: 'left', lineHeight: '1.8', marginTop: '1.5rem' }}>
          {renderText(scenario.detailed_scenario_description || "Detailed scenario description not available")}
        </div>
      </div>

      <div className="card">
        <h2>Choose Your Role</h2>
        <p style={{ marginBottom: '2rem' }}>Select the role you'll play in this future:</p>
        
        {roles.map((role, index) => (
          <div 
            key={index} 
            className="role-card" 
            onClick={() => onRoleSelect(role)}
          >
            <div className="role-name">{role.name}</div>
            <div className="role-description">
              {renderText(role.description || "No description available")}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RoleSelection;